import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useFirmwareTypesStore = defineStore('firmwareTypes', {
  state: () => ({
    data: undefined,
    options: undefined,
  }),
  getters: {
    getFirmwareTypes: (state) => state.data?.data,
    getFirmwareTypeOptions: (state) => state.options?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexFirmwareTypeOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'firmware_types');
          const response = await axios.get('firmware-types', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexFirmwareTypes(params = {}) {
      try {
        const response = await axios.get('firmware-types', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createFirmwareType(params = {}) {
      try {
        const response = await axios.get('firmware-types/create', {params});
        return useCreateForm('firmware-types', response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showFirmwareType(firmwareTypeId, params = {}) {
      try {
        const response = await axios.get(`firmware-types/${ firmwareTypeId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editFirmwareType(firmwareTypeId, params = {}) {
      try {
        const response = await axios.get(`firmware-types/${ firmwareTypeId }/edit`, {params});
        return useEditForm(`firmware-types/${ firmwareTypeId }`, response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteFirmwareType(firmwareTypeId, params = {}) {
      try {
        const response = await axios.delete(`firmware-types/${ firmwareTypeId }`, {params});
        this.options = undefined;
        toasteventbus.emit('add', {
          summary: 'Firmware Type Deleted',
          detail: `Firmware Type has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
